// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RDEr9","col":"styles_col___BXsh"};